<template>
  <div>
    <z-header :title="title" :actions="actions"></z-header>
    <Form :data="entry" :isEdit="true" @save="save" />
  </div>
</template>

<script>
import ZHeader from "../../layout/Header";
import fleetVehicle from "../../services/fleetVehicle";
import Form from "./Form.vue";
import { registrationPlate } from '../../filters/registration-plate';

export default {
  data() {
    return {
      title: "Editar veículo",
      id: null,
      entry: {},
      isLoading: false,
      actions: []
    };
  },
  mounted() {
    this.id = this.$route.params.id;

    this.actions.push({
      label: "Excluir",
      route: `/veiculos/${this.id}/remover`,
      class: "is-danger"
    });

    this.loadData();
  },
  methods: {
    loadData() {
      fleetVehicle.get(this.id).then(data => {
        this.entry = data;

        this.entry.registrationPlate = registrationPlate(this.entry.registrationPlate);
      });
    },
    async save(rawData) {
      try {
        await fleetVehicle.update(this.id, rawData);

        this.$router.push({
          name: "fleetVehicle"
        });
      } catch (err) {
        const {
          response: { data }
        } = err;

        const message = data.message && data.message.error ? data.message.error : "Erro ao atualizar o veículo";

        this.$buefy.toast.open({
          message,
          type: "is-danger"
        });
      }
    }
  },
  components: {
    ZHeader,
    Form
  }
};
</script>

<style lang="scss"></style>
